import { useWebEDIStore } from 'stores/webedi/webedi';
import { IssueResolverType } from 'support/types';

export const useIsPartnerIssueResolver = (): boolean => {
  const issueResolver = useWebEDIStore((state) => state.issueResolver);
  return issueResolver === IssueResolverType.CURRENT_PARTNER;
};
